import GlobalOverride from "views/logic/search/GlobalOverride";
import { selectView, selectActiveQuery } from "views/logic/slices/viewSelectors";
import SearchExecutionState from "views/logic/search/SearchExecutionState";
import {
  selectGlobalOverride,
  selectParameterBindings,
  selectSearchExecutionResult
} from "views/logic/slices/searchExecutionSelectors";
import { executeWithExecutionState } from "views/logic/slices/searchExecutionSlice";
const reexecuteSearchTypes = (searchTypes, effectiveTimerange) => (dispatch, getState, { searchExecutors }) => {
  const state = getState();
  const activeQuery = selectActiveQuery(state);
  const globalOverride = selectGlobalOverride(state);
  const globalQuery = globalOverride == null ? void 0 : globalOverride.query;
  const parameterBindings = selectParameterBindings(state);
  const view = selectView(state);
  const searchTypeIds = Object.keys(searchTypes);
  const newGlobalOverride = new GlobalOverride(
    effectiveTimerange,
    globalQuery,
    searchTypeIds,
    searchTypes
  );
  const executionState = new SearchExecutionState(parameterBindings, newGlobalOverride);
  const handleSearchResult = ({ result: newPartialSearchResult }) => {
    const { result: existingSearchResult } = selectSearchExecutionResult(getState());
    const updatedSearchTypes = newPartialSearchResult.getSearchTypesFromResponse(searchTypeIds);
    const updatedSearchResult = existingSearchResult.withErrors(newPartialSearchResult.result.errors).updateSearchTypes(updatedSearchTypes);
    return { result: updatedSearchResult, widgetMapping: view.widgetMapping };
  };
  return dispatch(
    executeWithExecutionState({
      search: view.search,
      activeQuery,
      searchTypesToSearch: [],
      executionState,
      searchExecutors: {
        ...searchExecutors,
        resultMapper: handleSearchResult
      },
      widgetMapping: view.widgetMapping
    })
  );
};
export default reexecuteSearchTypes;
